import React, { createContext, useState, useContext } from 'react';
//import {useNavigate} from "react-router-dom";

const ModalContext = createContext();
//const navigate = useNavigate();

export const ModalProvider = ({ children }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState(null);
    const [navigateTo, setNavigateTo] = useState(null);


    const updateModalContent = (content) => {
        setModalContent(content);
    };

    // const clickAction = () => {
    //     closeModal();
    //     navigate(navigateTo);
    // }

    const openModal = (content, actionLink) => {
        setModalContent(content);
        setNavigateTo(actionLink)
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setModalContent(null);
        setIsModalOpen(false);
    };

    return (
        <ModalContext.Provider value={{ isModalOpen, openModal, closeModal, modalContent, updateModalContent, navigateTo }}>
            {children}
        </ModalContext.Provider>
    );
};

export const useModal = () => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('useModal must be used within a ModalProvider');
    }
    return context;
};